/**
 * NavigationArrow - Reusable navigation arrow button for detail views
 * Displays previous/next navigation with consistent styling
 */
export default function NavigationArrow({
  direction = 'previous', // 'previous' or 'next'
  onClick,
  disabled = false,
  label = '',
  className = ''
}) {
  const isNext = direction === 'next';
  const defaultLabel = isNext
    ? (disabled ? 'No next item' : 'Next')
    : (disabled ? 'No previous item' : 'Previous');

  const arrowPath = isNext
    ? 'M9 5l7 7-7 7' // Right arrow
    : 'M15 19l-7-7 7-7'; // Left arrow

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`flex-shrink-0 p-2 rounded-lg transition-all duration-200 ${
        disabled
          ? 'text-gray-700 cursor-not-allowed'
          : 'text-purple-400 hover:bg-gray-700 hover:text-purple-300'
      } ${className}`}
      title={label || defaultLabel}
    >
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={arrowPath} />
      </svg>
    </button>
  );
}
